export default class VeteranTypeService {
    static fromJSON(json) {
        // @ts-expect-error - TS2739 - Type '{ id: number; }' is missing the following properties from type 'VeteranType': name, description
        return Object.assign(Object.assign({}, json), { id: parseInt(json.id, 10) });
    }
}
